// /bootstrap payload (site config, flags, notices, shops) cached in the shop DB so it also works offline.
import { create } from 'zustand';
import { FEATURE_FLAG_DEFAULTS, type FeatureFlags } from '@dd/shared';
import { api } from '@/lib/api';
import { hasDb, metaGet, metaSet } from '@/db';

export interface Notice { id: string; titleBn: string; bodyBn: string; titleEn?: string | null; bodyEn?: string | null; severity: string; endsAt: string }
export interface SiteContact { whatsapp?: string; phone?: string; email?: string; [k: string]: unknown }
export interface BootData {
  config: { support: { contact: SiteContact; hours: Record<string, unknown> }; legal: Record<string, string>; minVersion?: string };
  flags: FeatureFlags;
  notices: Notice[];
  shops: Array<{ id: string; name: string; category: string; archived: boolean }>;
  serverTime?: string;
}
interface BootState { data: BootData | null; load: () => Promise<void>; restore: () => Promise<void> }

export const useBoot = create<BootState>((set) => ({
  data: null,
  async restore() {
    if (!hasDb()) return;
    const cached = await metaGet<BootData>('bootstrap');
    if (cached) set({ data: cached });
  },
  async load() {
    try {
      const d = await api.get<BootData>('/bootstrap');
      set({ data: d });
      if (hasDb()) await metaSet('bootstrap', d);
    } catch { /* offline: keep the cached copy */ }
  },
}));

export const useFlags = (): FeatureFlags => useBoot((s) => s.data?.flags ?? FEATURE_FLAG_DEFAULTS);
